module.exports = __webpack_public_path__ + "482c6d585af7155c519467926b1b4684.png";